<template>
  <v-tooltip
    right
    color="white"
  >
    <template v-slot:activator="{ on }">
      <v-icon
        small
        v-on="on"
        style="cursor: pointer;"
      >
        info
      </v-icon>
    </template>

    <span class="black--text">
      <template v-for="(fee, index) in fees">
        <span>{{ getLabel(fee) }}</span>: <span v-money="{ amount: fee.amount, currency, hideCurrency: true }">{{ fee.amount }}</span><br />
      </template>
    </span>
  </v-tooltip>

</template>
<script>
import { get } from 'lodash'

export default {
  props: {
    currency: {
      type: String,
      default: ''
    },
    fees: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    getLabel(fee) {
      return get(fee, 'description', '')
        .trim()
        .charAt(0)
        .toUpperCase()
        + get(fee, 'description', '').trim().slice(1)
    }
  }
}
</script>
